import Component from '../core/Component';
import enquire from 'enquire.js';
import YouTubeIframeLoader from 'youtube-iframe'
const { forEach } = Array.prototype;

export default class Youtube extends Component {

    constructor(element) {
        super(element);

        this.$element = $(this.element)

        // disable tablet/phone
        this.disabled = false

        if(window.innerWidth < 1200 && Modernizr.touchevents){
            this.disabled = true
        }

        else if(window.innerWidth < 768){
            this.disabled = true
        }


        if (this.disabled) {
            return
        }

        if (this.$element.find('iframe') != null && this.parseUrl(this.$element.find('iframe').attr('src')) != null) {
            this.id = this.parseUrl(this.$element.find('iframe').attr('src'))
        } else {
            console.warn('Youtube iframe must be present in parent element.')
            return
        }

        this.player = null
        this.playerState = null
        this.duration = null
        this.currentTime = 0
        this.buffered = 0
        this.width = 640
        this.height= 360

        // place thumb
        if (this.$element.data('thumb') != null && this.$element.data('thumb') != '') {
            this.$thumb = $(`<div class="youtube__thumb"><img src="${this.$element.data('thumb')}"/></div>`)
        } else {
            this.$thumb = $(`<div class="youtube__thumb"><img src="https://img.youtube.com/vi/${this.id}/maxresdefault.jpg"/></div>`)
        }
        this.$element.append(this.$thumb)

        // set responsive size based on set size of iframe (fallback to 4:3)
        this.setSize()

        // replace iframe with fake holder
        // takhle to vyifuje jenom dva na jedny strance, vic ne
        if(document.getElementById('player')){
            this.$element.find('iframe').replaceWith('<div id="player2"></div>')
        }
        else{
            this.$element.find('iframe').replaceWith('<div id="player"></div>')
        }


        // controls
        this.prepareControls()
    }

    prepare () {


        if (!this.disabled){
            this.$element.addClass('is-initialized')
            this.$thumb.on('click', ::this.createVideo)
            this.$controls.on('click', event => {
                event.stopPropagation();
            })
            this.$thumb.on('click', event => {
                event.stopPropagation();
            })
            this.$volume.on('click', ::this.toggleMute)
            this.$volumeLine.on('click', ::this.handleVolumeLineClick)
            this.$volumeHolder.on('click', event => {
                event.stopPropagation()
            })
            this.isFullscreen = false;
            this.$fullscreen.on('click', ::this.toggleFullScreen)

            this.$timeline.on('click', ::this.handleTimelineClick);

            this.$element.on('click', ::this.togglePlay)
            this.$play.on('click', ::this.togglePlay)
            this.$play.on('click', event => {
                event.stopPropagation();
            })

            this.$link.on('click', event => {
                this.togglePlay();
            })

            // this.$qualityHolder.on('click', 'div', ::this.setQuality)
        }
    }

    dragVideo(event){
        var posX = this.$timeline.offset().left
        var coorInTimeline = event.pageX - posX
        this.$timelineCurrent.css('width', coorInTimeline)

        var percentage = coorInTimeline/this.$timeline.outerWidth()
        this.setTime(percentage*this.duration)
    }


    createVideo () {
        this.hideThumb()

        let playerName = this.$element.find('div')[0].id;

        YouTubeIframeLoader.load((YT)=> {
            this.player = new YT.Player(playerName, {
                playerVars: {
                    modestbranding: 1,
                    showinfo: 0,
                    controls: 0,
                    rel: 0
                },
                videoId: this.id,
                events: {
                    'onReady': ::this.onPlayerReady,
                    'onStateChange': ::this.onPlayerStateChange,
                    'onPlaybackQualityChange': ::this.onPlaybackQualityChange
                }
            });
        });



        this.$element.addClass('is-enabled')

        // setTimeout(()=>
        //     {console.log(this.$element.find("iframe")[0].contentWindow.document);
        // }
        //     ,3000);

        // this.$element.find("iframe")[0].contentWindow.document.addEventListener('keypress', function(event){

        //     alert('You enter!');

        // });

        document.addEventListener("fullscreenchange", ()=> {
        if (!document.fullscreenElement) this.fullScreenOut();
        }, false);

        document.addEventListener("msfullscreenchange", ()=> {
        if (!document.msFullscreenElement) this.fullScreenOut();
        }, false);

        document.addEventListener("mozfullscreenchange", ()=> {
        if (!document.mozFullScreen) this.fullScreenOut();
        }, false);

        document.addEventListener("webkitfullscreenchange", ()=> {
        if (!document.webkitIsFullScreen) this.fullScreenOut();
        }, false);
    }

    prepareControls () {
        this.$play = $('<div class="youtube__play"></div> ')

        this.$volume = $('<div class="youtube__volume"><i class="icon icon-volume"></i></div><div class="youtube__volume__holder"><div class="youtube__volume__line"><div class="youtube__volume__current"></div></div></div>')
        this.$volumeHolder = this.$volume.find('.youtube__volume__holder')
        this.$volumeLine = this.$volume.find('.youtube__volume__line')
        this.$volumeCurrent = this.$volume.find('.youtube__volume__current')

        this.$time = $('<div class="youtube__time"><div class="youtube__time__current">0:00</div> / <div class="youtube__time__full">0:00</div></div> ')
        this.$timeCurrent = this.$time.find('.youtube__time__current')
        this.$timeTotal = this.$time.find('.youtube__time__full')

        this.$timeline = $('<div class="youtube__timeline"><div class="youtube__timeline__current"></div><div class="youtube__timeline__buffered"></div></div> ')
        this.$timelineCurrent = this.$timeline.find('.youtube__timeline__current')
        this.$timelineBuffered = this.$timeline.find('.youtube__timeline__buffered')

        this.$quality = $('<div class="youtube__quality"><i class="icon icon-wheel"></i></div><div class="youtube__quality__holder"></div>')

        this.$fullscreen = $('<div class="youtube__fullscreen"><i class="icon icon-fullscreen"></i></div> ')
        this.$link = $('<div class="youtube__link"><a href="https://www.youtube.com/watch?v=' + this.id + '" target="_blank"><i class="icon icon-youtube"></i></a></div> ')

        this.$controls = $('<div class="youtube__controls"></div>')
        this.$controls.append(this.$play).append(this.$volume).append(this.$time).append(this.$timeline).append(this.$link).append(this.$fullscreen)
        this.$element.append(this.$controls)
        this.$qualityHolder = this.$element.find('.youtube__quality__holder')
    }

    hideThumb () {
        this.$thumb.remove();
    }

    togglePlay () {
        if (this.player === null) {
            this.$thumb.click()
            return
        }

        if (this.playerState == 0 || this.playerState == 2) {
            this.player.playVideo();
        } else {
            this.player.pauseVideo();
        }
    }

    toggleMute () {
        if (this.player.isMuted()) {
            this.player.unMute();
            this.$element.removeClass('is-muted');
        } else {
            this.player.mute();
            this.$element.addClass('is-muted');
        }
    }

    onPlayerReady(event) {
        event.target.playVideo();
        this.duration = this.player.getDuration();
        this.$timeTotal.text(this.formatTime(this.duration));

        let dragVideoFn = ::this.dragVideo;

        this.$timeline.on('mousedown', (event)=>{
            // this.player.pauseVideo();
            this.$element.on('mousemove', dragVideoFn);
        });

        this.$element.on('mouseup', (event)=>{
            // setTimeout(()=>{
                // this.player.playVideo();
            // }, 10)

            this.$element.off('mousemove', dragVideoFn);
        });

    }

    onPlayerStateChange(event) {
        // save state
        this.playerState = event.data

        // assign class for styles
        var classNames = {
            '-1': 'unstarted',
            '0': 'ended',
            '1': 'playing',
            '2': 'paused',
            '3': 'buffering',
            '5': 'cued'
        }

        for(var key in classNames) {
            this.$element.removeClass(`is-${classNames[key]}`)
        }
        this.$element.addClass(`is-${classNames[this.playerState]}`)

        // loop for timing when playing
        var loop = null

        if (this.playerState == 1) {
            loop = setInterval(() => {
                this.updateTime()
            }, 1000)
        } else {
            clearInterval(loop)
        }

        // loop for buffer update
        var loopBuffer = setInterval(() => {
            this.buffered = this.player.getVideoLoadedFraction()
            this.$timelineBuffered.css('width', `${this.buffered * 100}%`);
            if (this.buffered == 1) {
                clearInterval(loopBuffer)
            }
        }, 1000)

        this.setVolume(this.player.getVolume())

        // quality
        this.avalableQuality = this.player.getAvailableQualityLevels();
        this.$qualityHolder.empty();
        this.avalableQuality.forEach((item) => {
            this.$qualityHolder.append(`<div data-id="${item}">${this.getSizeFromQuality(item)}</div>`);
        });

        this.onPlaybackQualityChange();
    }

    getSizeFromQuality(quality) {
        let size = '';
        switch(quality) {
            case 'hd1080':
                size = '1080p';
                break;
            case 'hd720':
                size = '720p';
                break;
            case 'large':
                size = '480p';
                break;
            case 'medium':
                size = '360p';
                break;
            case 'small':
                size = '240p';
                break;
            case 'small':
                size = '240p';
                break;
            case 'tiny':
                size = '140p';
                break;
            case 'auto':
                size = '';
                break;
        }
        return size;
    }

    updateTime () {
        this.currentTime = this.player.getCurrentTime()
        this.$timeCurrent.text(this.formatTime(this.currentTime))
        this.updateTimelineTime()
    }

    updateTimelineTime () {
        if (this.$element.hasClass('is-playing')){
            this.$timelineCurrent.css('width', `${this.currentTime/this.duration * 100}%`)
        }
    }

    exitFullScreen(){
        if(document.exitFullscreen) {
            document.exitFullscreen();
        } else if(document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
        } else if(document.webkitExitFullscreen) {
            document.webkitExitFullscreen();
        }
    }


    toggleFullScreen () {
        if(!this.isFullscreen){
            this.$element.addClass('is-fullscreen');

            var requestFullScreen = this.element.requestFullScreen || this.element.mozRequestFullScreen || this.element.webkitRequestFullScreen

            if (requestFullScreen) {
                requestFullScreen.bind(this.element)()
            }
            this.isFullscreen = true;
        }
        else{
            this.exitFullScreen();
            this.fullScreenOut();
        }

    }


    fullScreenOut(){

        this.$element.removeClass('is-fullscreen');
        this.isFullscreen = false;
    }

    handleTimelineClick (event) {
        var posX = this.$timeline.offset().left
        var coorInTimeline = event.pageX - posX
        var percentage = coorInTimeline/this.$timeline.outerWidth()
        this.setTime(percentage*this.duration)
        this.player.playVideo();
    }


    parseUrl (url) {
        console.log(url);
        var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
        var match = url.match(regExp);
        return (match&&match[7].length==11)? match[7] : false;
    }

    setTime (time) {
        this.player.seekTo(time, true)
    }

    formatTime (time)  {
        return `${Math.floor(time/60)}:${Math.floor(time%60) < 10 ? '0' +Math.floor(time%60) : Math.floor(time%60)}`
    }

    setSize () {
        this.width = this.$element.find('iframe').attr('width')
        this.height = this.$element.find('iframe').attr('height')

        if (this.width && this.height) {
            var ratio = this.height/this.width*100
            ratio = Math.floor(ratio) - 0.1;
            this.$element.css({'padding-bottom': `${this.$element.hasClass('youtube--fixed-controls') ? "calc(" + ratio + "% + 56px)" : ratio + "%"}`})
        } else {
            this.width = 640
            this.height = 360
        }
    }

    handleVolumeLineClick (event) {
        event.stopPropagation()
        var posY = this.$volumeLine.offset().top
        var coorInTimeline = (event.pageY - posY - this.$volumeLine.outerHeight()) * -1
        var percentage = coorInTimeline/this.$volumeLine.outerHeight()
        this.setVolume(percentage * 100)
    }

    setVolume (volume) {
        // 0 - 100
        this.player.setVolume(volume)
        this.$volumeCurrent.css({'height': `${volume}%`})
    }

    setQuality(event) {
        this.player.pauseVideo()
        this.player.setPlaybackQuality($(event.currentTarget).data('id'));
        this.player.playVideo()
    }

    onPlaybackQualityChange() {
        let quality = this.player.getPlaybackQuality();
        this.$qualityHolder.find('div').removeClass('is-active');
        this.$qualityHolder.find(`[data-id="${quality}"]`).addClass('is-active');
        if (quality == 'hd1080' || quality == 'hd720') {
            this.$element.addClass('is-hd');
        } else {
            this.$element.removeClass('is-hd');
        }
    }
}